import widgetInfo from './widgetInfoSlice';

const root = {
	widgetInfo
};

export default root;
